import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Category, Question } from '../../../types/questions';

export type AnswerSliceInterface = {
    [key in Category]: Question | null;
};

const initialState: AnswerSliceInterface = {
    personality: null,
    priority: null,
    typical: null,
    seating: null,
    iceEv: null,
    budget: null
};

const answerSlice = createSlice({
    name: 'answerSlice',
    initialState,
    reducers: {
        set: (state, action: PayloadAction<{key: Category, value: Question | null}>) => {
            const { key, value } = action.payload;
            state[key] = value;
        },

        reset : () => initialState
    },
});

export const { set, reset } = answerSlice.actions;
export default answerSlice.reducer;
